// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Tooltip_tooltipWrapper__ObxHs","tooltipContent":"Tooltip_tooltipContent__ZtOCV","visible":"Tooltip_visible__eNU+X","text":"Tooltip_text__+5zZ0"};